import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import FlagRounded from '@mui/icons-material/FlagRounded';
import { ROUTES } from 'constants/RoutePaths';
import { useGetPlanQuery, useStartPlanMutation } from 'app/api/planApiSlice';
import TSButton from 'components/common/Button/Button';
import Notice from 'components/common/Notice/Notice';
import MLToast from 'components/common/Toast/Toast';
import GearList from 'components/TrailSafe/GearList/GearList';

// The last-minute check before a Plan starts: its Gear List, still editable,
// as a reminder of anything forgotten. Starting fixes the list (ADR-0017), so
// the walker always sees it first, however long ago they planned. qrCode is
// the QR Code they scanned to get here, if any, recorded on the check-in.
const StartPlanCheck = ({ planId, qrCode = null, toggleModal }) => {
  const navigate = useNavigate();
  const { showToast } = MLToast();
  const { data: plan, isLoading, error } = useGetPlanQuery(planId);
  const [startPlan, { isLoading: isStarting }] = useStartPlanMutation();

  const handleStart = async () => {
    const res = await startPlan({ planId, qrCode });
    if (res.data) {
      showToast('Activity started. Have a safe walk.', 'success');
      toggleModal(false);
      navigate(`/${ROUTES.HOME}`);
    } else {
      showToast(res.error?.data?.message || 'Something went wrong!', 'error');
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading your Plan.</div>;

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="h2">Before you go</Typography>
      <Typography variant="body1" color="text.secondary">
        {plan.trail_name}, {plan.park_name}
      </Typography>
      <Notice tone="info" title="Check your gear one last time">
        Once you start, your Gear List can't be changed.
      </Notice>
      <GearList
        planId={plan.plan_id}
        gearList={plan.gear_list}
        editable={plan.editable}
      />
      <div className="grid grid-cols-2 gap-3 mt-2">
        <TSButton
          btnText={isStarting ? 'Starting...' : 'Start walk'}
          icon={<FlagRounded />}
          btnDisable={isStarting}
          onClickFunc={handleStart}
        />
        <TSButton
          btnText="Cancel"
          btnVariant="outlined"
          onClickFunc={() => toggleModal(false)}
        />
      </div>
    </div>
  );
};

export default StartPlanCheck;
